"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateVenueSigners = exports.getAuthorization = exports.prepareUpdateVenueSigners = void 0;
const lodash_1 = require("lodash");
const internal_1 = require("../../internal");
const types_1 = require("../../types");
const conversion_1 = require("../../utils/conversion");
const internal_2 = require("../../utils/internal");
/**
 * @hidden
 */
function prepareUpdateVenueSigners(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { context: { polymeshApi: { tx: { settlement }, consts: { settlement: { maxNumberOfVenueSigners }, }, }, }, context, } = this;
        const { signers, addSigners, venue } = args;
        const allowedSigners = yield venue.getAllowedSigners();
        const allowedSignerAddresses = allowedSigners.map(({ address }) => address);
        const signerParams = signers.map(signer => (0, internal_2.asAccount)(signer, context).address);
        if (addSigners) {
            const present = (0, lodash_1.intersection)(signerParams, allowedSignerAddresses);
            if (present.length) {
                throw new internal_1.PolymeshError({
                    code: types_1.ErrorCode.UnmetPrerequisite,
                    message: 'One or more of the supplied signers are already added to the Venue',
                    data: {
                        present,
                    },
                });
            }
            const maxVenueSigners = (0, conversion_1.u32ToBigNumber)(maxNumberOfVenueSigners);
            if (maxVenueSigners.lt(allowedSignerAddresses.length + signerParams.length)) {
                throw new internal_1.PolymeshError({
                    code: types_1.ErrorCode.UnmetPrerequisite,
                    message: 'Maximum number of venue signers exceeded',
                    data: { maxVenueSigners },
                });
            }
        }
        else {
            const absent = (0, lodash_1.difference)(signerParams, allowedSignerAddresses);
            if (absent.length) {
                throw new internal_1.PolymeshError({
                    code: types_1.ErrorCode.UnmetPrerequisite,
                    message: 'One or more of the supplied signers are not added to the Venue',
                    data: {
                        absent,
                    },
                });
            }
        }
        return {
            transaction: settlement.updateVenueSigners,
            args: [
                (0, conversion_1.bigNumberToU64)(venue.id, context),
                signerParams.map(signer => (0, conversion_1.stringToAccountId)(signer, context)),
                (0, conversion_1.booleanToBool)(addSigners, context),
            ],
            resolver: undefined,
        };
    });
}
exports.prepareUpdateVenueSigners = prepareUpdateVenueSigners;
/**
 * @hidden
 */
function getAuthorization({ venue: { id: venueId } }) {
    return {
        roles: [{ type: types_1.RoleType.VenueOwner, venueId }],
        permissions: {
            assets: [],
            portfolios: [],
            transactions: [types_1.TxTags.settlement.UpdateVenueSigners],
        },
    };
}
exports.getAuthorization = getAuthorization;
/**
 * @hidden
 */
const updateVenueSigners = () => new internal_1.Procedure(prepareUpdateVenueSigners, getAuthorization);
exports.updateVenueSigners = updateVenueSigners;
//# sourceMappingURL=updateVenueSigners.js.map